<script setup>
import { ref } from 'vue'
import { PhX } from '@phosphor-icons/vue'
import logo from '@/../images/logo.jpg'

defineProps({ openSidebar: Boolean })
const emit = defineEmits(['close'])
const schoolName = "Bn Mas'ud College"

const menuEl = ref(null)
const scrollActiveIntoView = () => {
  const el = menuEl.value?.querySelector('[data-active="true"]')
  if (el) el.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
}
defineExpose({ scrollActiveIntoView })
</script>

<template>
  <div
    v-if="openSidebar"
    class="fixed inset-0 bg-black/40 z-30 md:hidden"
    @click="emit('close')"
  />
  <aside
    :class="[
      'bg-primary fixed top-0 left-0 h-screen w-[250px] z-40 flex flex-col',
      'transition-transform duration-300 ease-in-out shadow-xl',
      openSidebar ? 'translate-x-0' : '-translate-x-full',
      'md:translate-x-0',
    ]"
  >
    <div
      class="h-16 flex items-center gap-3 px-4 shrink-0 border-b"
      style="border-color: rgba(255,255,255,0.1);"
    >
      <div class="w-9 h-9 bg-white rounded-xl flex items-center justify-center shrink-0 ring-1 ring-white/20 p-1">
        <img :src="logo" class="w-full h-full object-contain rounded" />
      </div>
      <div class="flex flex-col leading-tight min-w-0">
        <span class="text-white font-bold text-sm tracking-wide truncate">{{ schoolName }}</span>
        <span class="text-white/50 text-xs">Staff Portal</span>
      </div>
      <button
        class="ml-auto text-white/50 hover:text-white/80 md:hidden transition shrink-0"
        @click="emit('close')"
      >
        <PhX :size="20" />
      </button>
    </div>

    <ul ref="menuEl" class="flex-1 overflow-y-auto py-4 px-3 space-y-0.5 scrollbar-hide list-none">
      <slot />
    </ul>
  </aside>
</template>

<style scoped>
.scrollbar-hide::-webkit-scrollbar { display: none; }
.scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
</style>